import { Link } from 'react-router';
import { Smartphone } from 'lucide-react';

import AppDownloadQR from '../app/AppDownloadQR.tsx';

type QRPopupProps = {
  show: boolean;
  className?: string;
};

export default function AppQRPopup({ show, className = '' }: QRPopupProps) {
  if (!show) return null;

  return (
    <div
      className={`absolute right-0 top-full mt-2 z-50 bg-white rounded-3xl shadow-xl p-4 w-64 border border-gray-200 ${className}`}>
      <div className="flex flex-col gap-4">
        <div>
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold mb-3">
            <Smartphone className="w-3 h-3" />
            <span>Get the App</span>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Scan the QR code
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            Download{' '}
            <Link
              to="/app"
              className="text-gray-600 hover:text-gray-700 hover:underline font-semibold">
              WhenWeMeet app
            </Link>{' '}
            on iOS and Android.
          </p>
        </div>
        <div className="flex justify-center bg-gray-50 rounded-lg p-4 border border-gray-200">
          <AppDownloadQR size={180} />
        </div>
        <div className="flex items-center justify-center gap-2 text-xs text-gray-500">
          <span>Free download</span>
          <span>•</span>
          <span>No sign-up required</span>
        </div>
      </div>
    </div>
  );
}
